import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "193efead-c8f9-4528-8da4-eb520c99ea4d",
    content: "Steps",
    options: {},
  },
  {
    id: "661adf59-3c33-4461-bccc-770697ad6146",
    content: "Speech",
    options: {},
  },
  {
    id: "9b741779-3719-458b-9a20-10864db2c427",
    content: "Washing machine",
    options: {},
  },
];

export const task: Task = {
  id: "fb20b8e9-2ff5-4895-b19a-4c34916241d0",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    columns: 1,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["661adf59-3c33-4461-bccc-770697ad6146"],
};
